import {doc, getDoc} from "firebase/firestore";
import {Auth, Firestore} from "../../../firebase/firebase";
import {UserProps} from "../../schemas/data/users/users";
import {useCallback} from "react";

export function useFbGetUser() {
  return useCallback(async () => {
    if (Auth.currentUser) {
      return await getDoc(doc(Firestore, "users", Auth.currentUser.uid))
        .then((res) => {
          return res.data() as UserProps;
        })
    } else {
      return null;
    }
  }, []);
}
